import { ActionButtonVariants } from 'components/action-button';

export default {
  buttonVariant: ActionButtonVariants.PRIMARY,
  hasBoxShadow: true,
  hasBorder: false,
};
